import { useEffect, useMemo, useState } from "react";
import { Box, Stack } from "@mui/material";

export default function StoreProductGallery({ product }) {
  const gallery = useMemo(() => {
    const items = [];

    if (product?.image) {
      items.push({
        id: "main-image",
        image: product.image,
      });
    }

    if (Array.isArray(product?.gallery)) {
      product.gallery.forEach((item, index) => {
        if (item?.image && !items.some((img) => img.image === item.image)) {
          items.push({
            id: item.id || `gallery-${index}`,
            image: item.image,
          });
        }
      });
    }

    if (!items.length) {
      items.push({
        id: "placeholder-image",
        image: "https://via.placeholder.com/900x900?text=NovaXfit",
      });
    }

    return items;
  }, [product]);

  const [selectedImage, setSelectedImage] = useState(gallery[0]?.image || "");
  const [zoomed, setZoomed] = useState(false);
  const [origin, setOrigin] = useState("50% 50%");

  useEffect(() => {
    setSelectedImage(gallery[0]?.image || "");
  }, [gallery]);

  const handleMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setOrigin(`${x}% ${y}%`);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        onMouseEnter={() => setZoomed(true)}
        onMouseLeave={() => setZoomed(false)}
        onMouseMove={handleMove}
        onClick={() => setZoomed((prev) => !prev)}
        sx={{
          width: "100%",
          maxWidth: "720px",
          mx: "auto",
          height: { xs: 290, sm: 360, md: 430, lg: 500 },
          borderRadius: "24px",
          border: "1px solid #e5e7eb",
          backgroundColor: "#ffffff",
          overflow: "hidden",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "zoom-in",
        }}
      >
        {product?.has_offer && (
          <Box
            sx={{
              position: "absolute",
              top: 16,
              left: 16,
              zIndex: 3,
              px: 1.1,
              py: 0.5,
              borderRadius: "999px",
              backgroundColor: "#ef4444",
              color: "#ffffff",
              fontSize: 10.5,
              fontWeight: 800,
              lineHeight: 1,
            }}
          >
            Oferta
          </Box>
        )}

        <Box
          component="img"
          src={selectedImage}
          alt={product?.name || "Producto"}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            p: { xs: 2, sm: 2.5, md: 3 },
            transform: zoomed ? "scale(1.7)" : "scale(1)",
            transformOrigin: origin,
            transition: zoomed ? "none" : "transform .25s ease",
            userSelect: "none",
          }}
        />
      </Box>

      <Stack
        direction="row"
        spacing={1}
        sx={{
          mt: 1.5,
          width: "100%",
          maxWidth: "720px",
          mx: "auto",
          overflowX: "auto",
          pb: 0.2,
        }}
      >
        {gallery.map((item, index) => {
          const active = item.image === selectedImage;

          return (
            <Box
              key={item.id || index}
              onClick={() => setSelectedImage(item.image)}
              sx={{
                width: { xs: 66, md: 76 },
                minWidth: { xs: 66, md: 76 },
                height: { xs: 66, md: 76 },
                borderRadius: "16px",
                border: active ? "2px solid #111827" : "1px solid #d1d5db",
                backgroundColor: "#ffffff",
                overflow: "hidden",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 0.65,
              }}
            >
              <Box
                component="img"
                src={item.image}
                alt={`${product?.name || "Producto"} ${index + 1}`}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
}